import {
  PaymentElement,
  useElements,
  useStripe
} from '@stripe/react-stripe-js';
import LoadingButton from 'components/common/LoadingButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Row } from 'react-bootstrap';

const PaymentForm = ({ redirectUrl }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isElementReady, setIsElementReady] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements || !isElementReady) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { error: submitError } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: redirectUrl
        }
      });

      // This will only be reached if there's an immediate error
      // (e.g., card declined). Successful payments redirect.
      if (submitError) {
        setError(submitError.message);
      }
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  const isFormDisabled = !stripe || !elements || !isElementReady || loading;

  return (
    <form onSubmit={handleSubmit} className="max">
      <Card className="shadow-none border mt-3">
        <Card.Body className="pb-1">
          <Row className="g-3">
            <PaymentElement onReady={() => setIsElementReady(true)} />
          </Row>
        </Card.Body>
        {error && <div className="text-danger px-3 py-2">{error}</div>}
        <Card.Footer className="d-flex justify-content-end">
          <LoadingButton
            loading={loading}
            disabled={isFormDisabled}
            type="submit"
            className="w-100 py-3 mt-3"
          >
            {!isElementReady ? 'Loading...' : 'Pay'}
          </LoadingButton>
        </Card.Footer>
      </Card>
    </form>
  );
};

PaymentForm.propTypes = {
  redirectUrl: PropTypes.string.isRequired
};

export default PaymentForm;
